import { defineFetch } from 'resift';
import { WidgetUpdateRequest } from 'pages/Homepage/typings';

const makeUpdateWidget = defineFetch({
  displayName: 'Update Widget',
  share: {
    namespace: 'widgets',
  },
  make: (widgetId: string) => ({
    request: (data: WidgetUpdateRequest) => ({ http }) =>
      http({
        method: 'PUT',
        route: `/widgets/${widgetId}`,
        data,
      }),
  }),
});

export default makeUpdateWidget;
